import React from 'react';
import styled, {
  ThemeProvider as StyledThemeProvider,
} from 'styled-components';
import nextTheme from './theme';

import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import { device } from './media-queries';

const GlobalStyle = createGlobalStyle`
  /* ${normalize} */
  @import url('https://fonts.googleapis.com/css?family=Playfair+Display');

  @font-face {
    font-family: 'Glober';
    font-weight: 400;

    font-display: fallback;
    src:  url(${require('../assets/fonts/glober/Glober_Regular.eot')});
    src:  url(${require('../assets/fonts/glober/Glober_Regular.eot')}?#iefix) format("embedded-opentype"),
          /* url(${require('../assets/fonts/glober/Glober_Regular.woff')}) format("woff"), */
          url(${require('../assets/fonts/glober/Glober_Regular.woff2')}) format("woff2"),
          url(${require('../assets/fonts/glober/Glober_Regular.ttf')}) format("truetype"),
          url(${require('../assets/fonts/glober/Glober_Regular.svg')}#Glober) format("svg");

  }

  @font-face {
    font-family: 'Glober';
    font-weight: 600;

    font-display: fallback;
    src:  url(${require('../assets/fonts/glober/Glober_xBold.eot')});
    src:  url(${require('../assets/fonts/glober/Glober_xBold.eot')}?#iefix) format("embedded-opentype"),
          /* url(${require('../assets/fonts/glober/Glober_xBold.woff')}) format("woff"), */
          url(${require('../assets/fonts/glober/Glober_xBold.woff2')}) format("woff2"),
          url(${require('../assets/fonts/glober/Glober_xBold.ttf')}) format("truetype"),
          url(${require('../assets/fonts/glober/Glober_xBold.svg')}#Glober) format("svg");

  }

  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
    font-size: 62.5%;

    @media only screen and ${device.tablet} {
      font-size: 50%;
    }
  }

  body {
    /* font-family: $font-primary;
    color: $color-grey-dark-2; */
    /* max-width: 1440px; */
    margin: 0 auto;
    font-weight: 300;
    line-height: 1.6;
  }

  h1 {
    font-size: 4.8rem;
    line-height: 1.1;
    max-width: 65rem;
  }

  h2 {
    font-size: 4.2rem;
    line-height: 1.2;
    max-width: 65rem;

    @media only screen and ${device.tablet} {
      font-size: 3.2rem;
    }
  }

  h3 {
    font-size: 2.8rem;
    line-height: 1.6;
    max-width: 65rem;
  }

  h4 {
    font-size: 2rem;
    line-height: 1.6;
    max-width: 65rem;
  }

  p {
    font-size: 1.6rem;
    max-width: 65rem;
  }
`;

interface Props {
  customBreakpoints?: number[];
  children: React.ReactChild;
}

export const Base = styled.div`
  color: ${props => props.theme.color};
  font-family: 'Glober', Arial, sans-serif;
  /* line-height: ${props => props.theme.lineHeights.standard}; */
  font-weight: ${props => props.theme.fontWeights.medium};
`;

const ThemeProvider = (props: Props) => {
  const { customBreakpoints, ...rest } = props;
  const breakpoints = customBreakpoints || nextTheme.breakpoints;
  const theme = {
    ...nextTheme,
    breakpoints,
  };

  return (
    <StyledThemeProvider theme={theme}>
      <>
        <GlobalStyle />
        <Base {...rest} />
      </>
    </StyledThemeProvider>
  );
};

export default ThemeProvider;
